module.exports = __webpack_public_path__ + "static/media/bac-headset.7462fe20.svg";